import { Component, OnInit, ViewChild, Input } from '@angular/core';
import { SharedService } from 'src/app/shared/shared.service';
import { AppConstants } from 'src/app/config.service';
import { finalize } from 'rxjs/operators';
import { UtilitiesService } from 'src/app/shared/utilities.service';


@Component({
    selector: 'email-recipients-tab',
    templateUrl: './email-recipients.component.html'
})
export class EmailRecipientsTabComponent implements OnInit {

    @Input() selection: any;

    constructor(
        private service: SharedService,
        private appConstants: AppConstants,
        public utiltiesService : UtilitiesService
    ) { }

    ngOnInit() {

    }

    ngOnChanges() {
        if (this.selection && this.selection.id) {
            this.recipients = [];
            this.getEmailRecipients(this.selection)
            this.emailRecipientsModal.show();
        }
    }

    @ViewChild('emailRecipientsModal', { static: true }) emailRecipientsModal: any;

    recipients: any = [];
    recipientsLoading: boolean = false;
    getEmailRecipients(selection) {
        this.recipientsLoading = true;
        let url = this.appConstants.endPoints.certificatesEndPoint + 'critical-components/applicant-component-selections/' + selection.id + '/email-recipients';
        this.service.get(url, {}, false)
            .pipe(finalize(() => {
                this.recipientsLoading = false;
            }))
            .subscribe(data => {
                this.recipients = data && data.length ? data : [];
            })
    }

}